module.exports = __webpack_public_path__ + "img/groupBuying.90c20549.png";